<template>
    <div class="flex items-center overflow-hidden whitespace-nowrap flex-nowrap w-full lg:w-456px  transform-gpu"
        :class="[isActive ? 'opacity-1 ease-out duration-100' : 'opacity-0 ease-in duration-100']">
        <div class="flex items-center flex-auto border font-main text-14 lg:text-16 rounded-lg leading-none"
            :class="[isActive ? 'border-a-brown-d7c7b8 bg-white' : 'border-transparent']">
            <div class="flex-none leading-none" :class="[isActive ? 'pl-3 lg:pl-4' : '']">
                <button type="button" class="appearance-none outline-none bg-none">
                    <img src="@/assets/icon/icon-search-gray.svg" />
                </button>
            </div>
            <div class="flex-auto px-2 leading-none h-full">
                <input ref="input" class="bg-transparent placeholder-a-brown-9f8273 w-full py-2.5 text-a-brown-502314"
                    maxlength="50" type="text" placeholder="Search menu" :value="searchComputed"
                    @input="onInput($event)" @keyup.enter="onEnter()" autocomplete="off" />
            </div>
            <div class="flex-none leading-none flex items-center" :class="[isActive ? 'pr-2.5' : '']">
                <button type="button" class="outline-none appearance-none bg-none" v-show="showBtnClear"
                    @click="clickClear()">
                    <img class="h-4 w-4 lg:h-5 lg:w-5" src="@/assets/icon/ic-close-brown.svg" />
                </button>
            </div>
        </div>
        <div class="leading-none flex-none">
            <button
                class="outline-none appearance-none bg-none text-14 lg:text-16 font-main font-bold text-a-red-d62300 px-3 lg:px-4"
                @click="cancelSearch()">
                Cancel
            </button>
        </div>
    </div>
</template>

<script>
import { computed, ref, nextTick, inject, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Utility from '@/helper/Utility'
import RegxHelper from '@/helper/RegxHelper'

export default {
    name: "TopBarSearch",
    emits: ["onShow", "onHidden"],
    setup: function () {
        const router = useRouter()
        const route = useRoute()
        const input = ref(null)

        const SearchStore = inject("SearchStore")
        const { searchTerm, isActive, searchBarMethods } = inject("SearchBarService")

        const searchComputed = computed({
            get: () => {
                return searchTerm.value
            },
            set: (val) => {
                searchTerm.value = val
            }
        })

        const showBtnClear = computed(() => {
            if (!Utility.isEmptyStr(searchComputed.value)) {
                return true
            }
            return false
        })

        //#region methods
        const onInput = function (e) {
            let value = e.target.value

            let input = Utility.isEmptyStr(value) ? '' : value;
            input = RegxHelper.removeEmoji(input);
            searchComputed.value = input
        }

        const validateInput = function () {
            // required
            if (Utility.isEmptyStr(searchComputed.value)) {
                return false;
            }

            return true
        }

        const clickClear = function () {
            searchComputed.value = ""
            nextTick(() => {
                input.value.focus()
            })
            SearchStore.emit("clear")
        }

        const onEnter = function () {
            let valid = validateInput()
            if (valid) {
                goToSearchPage()
            }
        }

        const showSearchInput = function () {
            console.log("request show")
            // isActive.value = true
            searchBarMethods.requestShow()
        }

        const hideSearcInput = function () {
            // isActive.value = false
            searchBarMethods.requestHide()
        }

        const cancelSearch = function () {
            hideSearcInput()

            nextTick().then(() => {
                if (route.name != "home") {
                    router.push({
                        name: "home"
                    })
                }
            })
        }

        const goToSearchPage = function () {
            if (route.name == "search") {
                if ((route.query?.q ?? "") == searchComputed.value) {
                    // same same word as on query string
                    SearchStore.emit("search")
                } else {
                    // word has change
                    router.replace({
                        query: {
                            q: searchComputed.value
                        }
                    })
                }
            } else {
                router.push({
                    name: "search",
                    query: {
                        q: searchComputed.value
                    }
                })
            }
        }
        //#endregion
        watch(isActive, (val) => {
            if (val) {
                setTimeout(() => {
                    nextTick(() => {
                        input.value.focus()
                    })
                }, 300);
            }
        })

        return {
            input,
            isActive,
            searchComputed,
            showBtnClear,
            onInput,
            onEnter,
            clickClear,
            showSearchInput,
            hideSearcInput,
            cancelSearch
        }
    },
}
</script>
